/** ログイン種別 */
class LoginType {
  /** 利用前 */
  static LOGIN_ID = { code: '0', name: 'ID' };
  /** 利用可 */
  static SSO_GOOGLE = { code: '1', name: 'SSO' };
  /** 利用不可 */
  static SSO_MICROSOFT = { code: '2', name: 'SSO' };

  /**
   * ログイン種別のコードから論理名を取得する
   * @param {string} code ログイン種別のコード
   * @returns ログイン種別の論理名
   */
   static getNameByCode(code){
    let name = '';
    if (!code) {
      return '';
    } else {
      for (const key in this) {
        if(this[key].code === code){
          name = this[key].name;
        }
      }
    }
    return name;
  }
}

module.exports = LoginType;